export default __webpack_public_path__ + "assets/icons/address.abc96579.svg";